module.exports = __webpack_public_path__ + "img/Paladin-human-f-60.2292c616.gif";